<template>
  <div class="be-content" v-if="guestVisit">
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="panel panel-default panel-border-color panel-border-color-primary">
            <div class="panel-heading panel-heading-divider">Редактирование записи о плательщике
            </div>
            <div class="panel-body">
              <guest-visit-form :guestVisit="guestVisit" ref="form" @dataIsValid="submitData"></guest-visit-form>
              <div class="row xs-pt-15">
                <div class="col-xs-12 text-center">
                  <button class="btn btn-space btn-success btn-lg" @click="validateDataForm">Сохранить изменения
                  </button>
                  <button class="btn btn-space btn-danger btn-lg" @click="$router.go(-1)">Отмена
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import axios from 'axios'
  import {mapGetters} from 'vuex'
  import momment from 'moment'
  import GuestVisitForm from './GuestVisitForm'

  export default {
    components: {GuestVisitForm},
    props: {
      visitId: {
        required: true
      }
    },
    data: function () {
      return {
        guestVisit: null
      }
    },
    created () {
      axios.get('/api/guest_visits/' + this.visitId + '/')
        .then(response => {
          this.guestVisit = response.data
        })
    },
    methods: {
      getItemValueFromDict (dictName, id, valueName) {
        return dictName.find(item => Number(item.id) === Number(id))[valueName]
      },
      getNameFromDict (dictName, id) {
        return dictName.find(item => Number(item.id) === Number(id)).name
      },
      submitData () {
        let data = this.guestVisit
        data['date_start'] = moment(this.guestVisit.date_start, "DD.MM.YYYY").format('YYYY-MM-DD')
        data['date_end'] = moment(this.guestVisit.date_end, "DD.MM.YYYY").format('YYYY-MM-DD')
        data['operator'] = this.guestVisit.operator.id
        if (this.guestVisit.privilege_category) {
          data['privilege_category'] = this.guestVisit.privilege_category.id
        }

        axios.patch('/api/guest_visits/' + this.visitId + '/', data)
          .then((response) => {
            if (response.status === 200) {
              this.$router.go(-1)
              this.$snotify.success('Изменения сохранены.', 'Успешно!')
            }
          })
          .catch((error) => {
            if (error.response.status >= 400) {
              this.$snotify.error(error.response.data.detail, 'Ошибка!', {timeout: 10000})
              this.$refs.form.updateFieldValue()
            }
          })
      },
      validateDataForm: function () {
        this.$refs.form.validate()
      },
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/guests/GuestVisitEdit.vue